import { defineComponent, ref, onMounted, nextTick, computed, watch, onUnmounted } from "vue";
import "../../../../services/main.mjs";
import { roomService } from "../../../../services/roomService.mjs";
import "../../../../locales/index.mjs";
import "@tencentcloud/tuiroom-engine-js";
import "../../../../utils/environment.mjs";
import { formatTimestampToTime } from "../../../../utils/utils.mjs";
import "mitt";
import "../../../../services/manager/roomActionManager.mjs";
import "@tencentcloud/tui-core";
import { MetricsKey } from "../../../../services/manager/dataReportManager.mjs";
import { AI_TASK } from "../../../../services/function/aiTask.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "AITranscription",
  setup(__props) {
    const conversationContainerRef = ref();
    const isUserScrolling = ref(false);
    const timeInterval = 60 * 1e3;
    const rawTranscribedMessageList = ref(
      roomService.aiTask.transcribedMessageList
    );
    onMounted(() => {
      scrollToBottom();
    });
    const scrollToBottom = async () => {
      if (conversationContainerRef.value && !isUserScrolling.value) {
        await nextTick();
        conversationContainerRef.value.scrollTop = conversationContainerRef.value.scrollHeight;
      }
    };
    const handleScroll = () => {
      if (conversationContainerRef.value) {
        const isAtBottom = conversationContainerRef.value.scrollTop + conversationContainerRef.value.clientHeight >= conversationContainerRef.value.scrollHeight - 5;
        if (isAtBottom) {
          isUserScrolling.value = false;
          scrollToBottom();
        } else {
          isUserScrolling.value = true;
        }
      }
    };
    const transcribedMessageList = computed(() => {
      const aggregatedMessageList = [];
      let currentAggregatedMessage = null;
      for (const message of rawTranscribedMessageList.value) {
        if (!currentAggregatedMessage || message.sender !== currentAggregatedMessage.sender || message.startMsTs - currentAggregatedMessage.startMsTs > timeInterval) {
          currentAggregatedMessage = {
            messages: [message],
            sender: message.sender,
            startMsTs: message.startMsTs
          };
          aggregatedMessageList.push(currentAggregatedMessage);
        } else {
          currentAggregatedMessage.messages.push(message);
        }
      }
      return aggregatedMessageList;
    });
    watch(rawTranscribedMessageList, () => {
      scrollToBottom();
    });
    const handleAITranscriptionTask = async (data) => {
      if (!data) return;
      rawTranscribedMessageList.value = [...data.transcribedMessageList];
    };
    onMounted(() => {
      roomService.dataReportManager.reportCount(MetricsKey.aiTask);
      roomService.aiTask.on(AI_TASK.TRANSCRIPTION_TASK, handleAITranscriptionTask);
    });
    onUnmounted(() => {
      roomService.aiTask.off(AI_TASK.TRANSCRIPTION_TASK, handleAITranscriptionTask);
    });
    return { __sfc: true, conversationContainerRef, isUserScrolling, timeInterval, rawTranscribedMessageList, scrollToBottom, handleScroll, transcribedMessageList, handleAITranscriptionTask, roomService, formatTimestampToTime };
  }
});
export {
  _sfc_main as default
};
